import { __awaiter } from "tslib";
import { ContrarefService } from "@/services/models/interconsult/contraref";
import { ProfessionService } from "@/services/models/profession";
import { NodeService } from "@/services/models/node";
import moment from "moment";
const moduleContrarefVisor = {
    namespaced: true,
    state: {
        filters: {
            profession_id: null,
            destination_node_id: Number(localStorage.getItem("stablishment")),
            date_start: null,
            date_end: null,
            patient_id: null,
        },
        counterReferralPaginated: {
            data: [],
            total: 0,
            per_page: 15,
            current_page: 1,
        },
        professionalTypes: [],
        establishments: [],
        loading: false,
    },
    mutations: {
        setFilters(state, filters) {
            state.filters = Object.assign(Object.assign({}, state.filters), filters);
        },
        resetFilters(state) {
            state.filters = {
                profession_id: null,
                destination_node_id: Number(localStorage.getItem("stablishment")),
                date_start: null,
                date_end: null,
                patient_id: null,
            };
        },
        setCounterReferralData(state, paginatedData) {
            if (paginatedData && paginatedData.data) {
                state.counterReferralPaginated = paginatedData;
            }
            else {
                state.counterReferralPaginated = {
                    data: [],
                    total: 0,
                    per_page: 15,
                    current_page: 1,
                };
            }
        },
        setProfessionalTypes(state, types) {
            state.professionalTypes = types;
        },
        setEstablishments(state, establishments) {
            state.establishments = establishments; // <--- Nueva mutación
        },
        setLoading(state, loading) {
            state.loading = loading;
        },
        setPage(state, page) {
            state.counterReferralPaginated.current_page = page;
        },
    },
    actions: {
        // Aquí se conecta oficialmente con getFilter de tu servicio
        fetchCounterReferrals({ commit, state }) {
            return __awaiter(this, void 0, void 0, function* () {
                commit("setLoading", true);
                try {
                    const apiFilters = Object.assign(Object.assign({}, state.filters), { date_start: state.filters.date_start ? moment(state.filters.date_start).format("YYYY-MM-DD") : null, date_end: state.filters.date_end ? moment(state.filters.date_end).format("YYYY-MM-DD") : null });
                    const response = yield ContrarefService.getFilter(apiFilters, state.counterReferralPaginated.current_page);
                    commit("setCounterReferralData", response);
                }
                catch (error) {
                    console.error("Error al obtener contra-referencias filtradas", error);
                }
                finally {
                    commit("setLoading", false);
                }
            });
        },
        fetchProfessionalTypes({ commit }) {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    const types = yield ProfessionService.getAll();
                    commit("setProfessionalTypes", types);
                }
                catch (error) {
                    console.error("Error al cargar tipos de profesionales", error);
                }
            });
        },
        fetchEstablishments({ commit }) {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    const DERIVATIONS = yield NodeService.getAll();
                    commit("setEstablishments", DERIVATIONS);
                }
                catch (error) {
                    console.error("Error al cargar establecimientos", error);
                }
            });
        },
        exportCounterReferrals({ state }) {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    // Preparamos los filtros asegurando que las fechas viajen como string YYYY-MM-DD
                    const apiFilters = Object.assign(Object.assign({}, state.filters), { date_start: state.filters.date_start ? moment(state.filters.date_start).format("YYYY-MM-DD") : null, date_end: state.filters.date_end ? moment(state.filters.date_end).format("YYYY-MM-DD") : null });
                    const response = yield ContrarefService.exportExcel(apiFilters);
                    // Creamos un enlace temporal para descargar el archivo blob que retorna Laravel
                    const url = window.URL.createObjectURL(new Blob([response]));
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("download", "reporte_contra_referencias.xlsx");
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    window.URL.revokeObjectURL(url);
                }
                catch (error) {
                    console.error("Error al exportar el reporte a Excel", error);
                }
            });
        },
    },
    getters: {
        filters: (state) => state.filters,
        professionalTypes: (state) => state.professionalTypes,
        establishments: (state) => state.establishments,
        counterReferralPaginated: (state) => state.counterReferralPaginated,
        loading: (state) => state.loading,
    },
};
export default moduleContrarefVisor;
